<template>
  <a-card
    title="Historial de gestión"
    :bordered="false"
    bodyStyle="padding: 0;"
  >
    <a-card>
      <a-timeline>
        <a-timeline-item v-for="log in stateLogs" :key="log.id">
          <a-row :gutter="[8, 8]" justify="start">
            <a-col>
              <IntegrationMovementStateTag
                :state-id="log.state.id"
                :state-tag="log.state.tag"
              />
            </a-col>

            <a-col>
              <a-typography-text type="secondary">
                {{ formatDate(log.createdAt) }}
              </a-typography-text>
            </a-col>

            <a-col v-if="log.comment" :span="24">
              <a-typography-text>
                {{ log.comment }}
              </a-typography-text>
            </a-col>

            <a-col v-if="log.changedBy" :span="24">
              <a-typography-text type="secondary">
                Modificado por:
                <strong>{{ log.changedBy.name }}</strong>
              </a-typography-text>
            </a-col>

            <a-col v-if="!log.changedBy" :span="24">
              <a-typography-text type="secondary">
                Modificado por:
                <strong>Sistema</strong>
              </a-typography-text>
            </a-col>
          </a-row>
        </a-timeline-item>
      </a-timeline>

      <a-empty
        v-if="!stateLogs || stateLogs.length === 0"
        description="No hay historial de gestión disponible"
      />
    </a-card>
  </a-card>
</template>
<script setup>
import IntegrationMovementStateTag from './integration-movement-state-tag.vue';
import { defineProps } from 'vue';

defineProps({
  stateLogs: {
    type: Array,
    default: () => []
  }
});

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('es-CL');
};
</script>
